/* https://env.t3.gg/docs/core */
import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

export const env = createEnv({
  client: {
    VITE_API_SERVER_URL: z.string().min(1),
    VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
    VITE_COMMIT_SHA: z.string().min(1).optional(),
    VITE_COMMIT_TIMESTAMP: z.string().optional(),
    VITE_DATADOG_APPLICATION_ID: z.string().min(1).optional(),
    VITE_DATADOG_CLIENT_TOKEN: z.string().min(1).optional(),
    VITE_DATADOG_SERVICE: z.string().min(1).optional(),
    VITE_DATADOG_SITE: z.string().min(1).optional(),
    VITE_JOYFUL_APP_WEB_ORIGIN: z.string().url().optional(),
    VITE_JOYFUL_BPO_WEB_ORIGIN: z.string().url().optional(),
    VITE_JOYFUL_ENV: z.enum(['development', 'staging', 'production']),
    VITE_JOYFUL_INTERNAL_WEB_ORIGIN: z.string().url().optional(),
    VITE_JOYFUL_SIDECAR_EXTENSION_ID: z.string().min(1),
    VITE_JOYFUL_VAULT_EXTENSION_ID: z.string().min(1),
    VITE_JOYFUL_WORKSPACE_WEB_ORIGIN: z.string().url().optional(),
    VITE_VERCEL_GIT_COMMIT_MESSAGE: z.string().optional(),
    VITE_VERCEL_GIT_COMMIT_SHA: z.string().optional(),
    VITE_VERCEL_GIT_COMMIT_TIMESTAMP: z.string().optional(),
  },
  clientPrefix: 'VITE_',
  emptyStringAsUndefined: true,
  runtimeEnv: import.meta.env,
})
